import Typography from "@mui/material/Typography";
import MuiBackdrop, {
  BackdropProps as MuiBackdropProps,
} from "@mui/material/Backdrop";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import useStyles from "./styles";

type BackdropProps = MuiBackdropProps & {
  onClose: () => void;
  offer?: any;
};

const Backdrop = ({ open, offer, onClose }: BackdropProps) => {
  const styles = useStyles();

  return (
    <MuiBackdrop className={styles.backdrop} open={open} style={{ margin: 0 }}>
      <Container maxWidth="sm" sx={{ height: "100%" }}>
        <Stack height="100%">
          <Stack
            direction="row"
            columnGap={2}
            alignItems="center"
            py={2}
            px={1}
          >
            <IconButton color="inherit" onClick={onClose}>
              <i className="fi fi-rr-angle-small-left" />
            </IconButton>

            <Typography color="#FAFAFA" fontWeight={600}>
              {offer?.title}
            </Typography>
          </Stack>
          <div className={styles.imageContainer}>
            {open && offer?.image && (
              <img
                key={offer.image}
                className={styles.image}
                src={offer.image}
                alt="image-backdrop"
                loading="eager"
              />
            )}
          </div>
        </Stack>
      </Container>
    </MuiBackdrop>
  );
};

export default Backdrop;
